import { useNavigate } from "@tanstack/react-router";
import z from "zod";

import { audienceListSearchSchema, type AudiencesSearch } from "./types";

const AUDIENCE_LIST_RETURN_PREFIX = `audience-list`;

export const returnToAudienceSchema = z.object({
  returnTo: z.string().optional(),
});

export function encodeAudienceListReturn(search: AudiencesSearch): string {
  const params = new URLSearchParams();
  if (search.page != null) {
    params.set("page", String(search.page));
  }
  if (search.pageSize != null) {
    params.set("pageSize", String(search.pageSize));
  }
  if (search.search?.length) {
    params.set("search", search.search);
  }
  const value = AUDIENCE_LIST_RETURN_PREFIX + "?" + params.toString();
  return encodeURIComponent(value);
}

const defaultListSearch = audienceListSearchSchema.parse({});

function decodeAudienceListReturn(returnTo: string): AudiencesSearch {
  try {
    const raw = decodeURIComponent(returnTo);
    const queryStart = raw.indexOf("?");
    const queryString = queryStart >= 0 ? raw.slice(queryStart + 1) : "";
    const obj = Object.fromEntries(new URLSearchParams(queryString));
    return audienceListSearchSchema.parse(obj);
  } catch {
    return defaultListSearch;
  }
}

export const useGoBackToAudience = (siteId: string, returnTo?: string) => {
  const navigate = useNavigate();

  return () => {
    if (returnTo?.startsWith(AUDIENCE_LIST_RETURN_PREFIX)) {
      const params = decodeAudienceListReturn(returnTo);
      void navigate({
        to: "/people/$siteId/audiences",
        params: { siteId },
        search: params,
      });
    } else {
      void navigate({
        to: "/people/$siteId/audiences",
        params: { siteId },
        search: defaultListSearch,
      });
    }
  };
};
